import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useGRPCClient } from 'api/grpc/client';
import { Concept } from 'api/grpc/resources';
import { ConceptSelector } from './ConceptSelector/ConceptSelector';
import { conceptsWrapper, autocompleteWrapper } from './Concepts.styles';

type ConceptsProps = {
  explicitAppId?: string;
  explicitUserOrOrgId?: string;
  selectedConcepts: Concept[];
  setSelectedConcepts?: (concept: Concept[]) => void;
};
/**
 * Section for concept list and quick search
 */
export const Concepts = ({ explicitAppId, explicitUserOrOrgId, selectedConcepts, setSelectedConcepts = () => {} }: ConceptsProps): JSX.Element => {
  const { userOrOrgId, appId } = useRouter().query as { userOrOrgId: string; appId: string };
  const client = useGRPCClient();

  const onChange = useCallback(
    (concepts: Concept[]): void => {
      setSelectedConcepts(concepts);
    },
    [selectedConcepts],
  );

  return (
    <div className={conceptsWrapper}>
      <div className={autocompleteWrapper}>
        <ConceptSelector
          selectedConcepts={selectedConcepts}
          labeledConcepts={[]}
          onChange={(concepts: Concept[]) => onChange(concepts)}
          userOrOrgId={explicitUserOrOrgId || userOrOrgId}
          appId={explicitAppId || appId}
          client={client}
          isDisabled={false}
          showSelectAll
        />
      </div>
    </div>
  );
};
